module.exports = __webpack_public_path__ + "img/Twitter@2x.fad6ca05.png";